import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useMessageBus } from "@jti/fe-message-bus";
import { LinkBehaviour } from "../../../../components/LinkBehaviour";
import styles from "./SocialLinks.module.scss";
export const SocialLinks = ({ links, className = "", dataTestId = "socials" }) => {
    const messageBus = useMessageBus();
    const handleSocialClick = (event, socialNetwork) => {
        event.preventDefault();
        messageBus.publish("tracking.event", {
            payload: {
                event_name: "follow",
                additionalData: {
                    social_network: socialNetwork,
                },
            },
        });
        window.open(event.currentTarget.href, event.currentTarget.target);
    };
    return (_jsx("div", { className: classNames(styles.socialsWrapper, className), "data-testid": dataTestId, children: links.map(({ trackingName, link, image }) => (_jsx(LinkBehaviour, { className: styles.socialLink, href: link, target: "_blank", rel: "noreferrer", "data-testid": trackingName, onClick: (event) => handleSocialClick(event, trackingName), children: _jsx("img", { className: styles.socialImg, src: image.src, alt: image.alt }) }, trackingName))) }));
};
//# sourceMappingURL=SocialLinks.js.map